<span *ngIf="mgTitle !== undefined" class="tooltip-text">{{ mgTitle }}</span>
<ng-content [ngClass]="getIconColorClass()"></ng-content>
